import { NavbarSettingsForm } from "./navbar-settings-form";
import { NavbarSettingsHandler } from "./navbar-settings-handler";

export class NavbarSettingsListener {
    private readonly form: NavbarSettingsForm;

    private readonly handler: NavbarSettingsHandler;

    public constructor(form: NavbarSettingsForm, handler: NavbarSettingsHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.navbarSettingsBound === "1") return;
        root.dataset.navbarSettingsBound = "1";

        this.form.getToggles().forEach((toggle) => {
            toggle.addEventListener("click", (event) => {
                this.handler.handleToggleClick(event);
            });
        });

        const popover = this.form.getPopover();
        if (popover instanceof HTMLElement) {
            popover.addEventListener("click", (event) => {
                this.handler.handlePopoverClick(event);
            });

            popover.addEventListener("change", (event) => {
                this.handler.handleSettingsChanged(event);
            });
        }

        const overlay = this.form.getOverlay();
        if (overlay instanceof HTMLElement) {
            overlay.addEventListener("click", () => {
                this.handler.handleOverlayClick();
            });
        }

        document.addEventListener("keydown", (event) => {
            this.handler.handleEscapeKey(event);
        });

        document.addEventListener(
            "click",
            (event) => {
                this.handler.handleDocumentClick(event);
            },
            true,
        );
    }
}
